var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.999 18.786c.3 0 .597-.134.793-.39l.435-.565c.651 3.862 3.356 7.166 7.196 8.499 1.182.41 2.395.607 3.592.607 3.584 0 7.033-1.768 9.098-4.881.305-.46.179-1.081-.281-1.386-.462-.307-1.08-.179-1.387.281-2.249 3.394-6.512 4.83-10.365 3.49-3.197-1.11-5.427-3.893-5.903-7.125l.856.659c.439.335 1.066.255 1.402-.183.337-.438.256-1.065-.182-1.402 0 0-2.365-1.821-2.371-1.825-.497-.383-1.204-.598-1.654-.011l-2.02 2.623c-.337.438-.256 1.065.182 1.402.181.139.396.207.609.207z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.169 11.331c.459.305 1.08.179 1.387-.281 2.249-3.393 6.516-4.829 10.365-3.49 3.197 1.11 5.427 3.893 5.903 7.125l-.856-.659c-.439-.336-1.066-.256-1.402.183-.337.438-.256 1.065.182 1.402 0 0 2.365 1.82 2.371 1.825.506.389 1.197.607 1.654.011l2.02-2.623c.337-.438.256-1.065-.182-1.402s-1.066-.255-1.402.183l-.435.565c-.651-3.862-3.356-7.166-7.196-8.499-4.72-1.638-9.936.119-12.69 4.273-.305.461-.179 1.081.281 1.387z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/iconRefresh.e7e5be942f08796dd052d486a765ff6d.svg";
export { ForwardRef as ReactComponent };